module.exports = __webpack_public_path__ + "img/green-logo.4c7f0239.png";